import { FormikProps } from 'formik';
import * as React from 'react';
import { FormSummary } from '@alinta-digital/asg';
import { ReviewSubForm, ReviewSubFormCore } from '../../components/Review/';
import { DirectDebitForm } from '../Form/Form';
import FlaggedFeature from '../../utils/FlaggedFeature';
import { config } from '../../config';

interface ReviewSectionProps {
  formikProps: FormikProps<DirectDebitForm>;
  isEdit: boolean;
  onPreviousClick: () => void;
  onNextClick: () => void;
}

export const ReviewSection: React.FC<ReviewSectionProps> = ({
  formikProps,
  isEdit,
  onPreviousClick,
  onNextClick,
}) => {
  return (
    <>
      {isEdit && (
        <FlaggedFeature
          featureFlag={config.enableCoreIntegration}
          fallback={
            <ReviewSubForm
              formikProps={formikProps}
              isEdit={isEdit}
              onPreviousClick={onPreviousClick}
              onNextClick={onNextClick}
            />
          }
        >
          <ReviewSubFormCore
            formikProps={formikProps}
            isEdit={isEdit}
            onPreviousClick={onPreviousClick}
            onNextClick={onNextClick}
          />
        </FlaggedFeature>
      )}
      {!isEdit && <FormSummary heading="Step 4: Review and confirm" />}
    </>
  );
};
